import { Card, CardContainer } from './styles'

export const SelectionCard: React.FC<any> = (props) => {
  return (
    <CardContainer>
      <Card>{props.children}</Card>
    </CardContainer>
  )
}
